import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined)

export const activitiesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/audit/activities',
  validateSearch: (search) => z.object({ page, log: text, event: text, from: date, to: date }).parse(search),
  beforeLoad: requirePermission('audit.view'),
  component: lazyRouteComponent(() => import('./pages/activities-page'), 'ActivitiesPage'),
})

export const accessLogsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/audit/access-logs',
  validateSearch: (search) =>
    z
      .object({ page, event: z.enum(['login', 'screen']).optional().catch(undefined), from: date, to: date })
      .parse(search),
  beforeLoad: requirePermission('audit.view'),
  component: lazyRouteComponent(() => import('./pages/access-logs-page'), 'AccessLogsPage'),
})
